module.exports = __webpack_public_path__ + "img/gita1.2ba50684.png";